import React, { Component } from 'react';

import { 
  Add, 
  DeleteForever 
} from '@mui/icons-material';
import { Fab, Tooltip } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  SuggestionsForLevel,
  SuggestionsOfType
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SuggestionsOfTypeInput from "@dndComponents/feature/SuggestionsOfTypeInput";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import { CHARACTER_LEVELS } from "@dndModels/Constants";
import { DataType, isDataType } from '@dndModels/Types';

type Props = {
  obj: SuggestionsForLevel;
  onChange: (changed: SuggestionsForLevel) => void; 
  onDelete: () => void;
  disabled: boolean;
}

export interface State { 
  obj: SuggestionsForLevel;
  reloading: boolean;
  suggestions: SuggestionsOfType[];
  expanded_type: string;
}

const type_map: any = {
  "spell": "Spell",
  "cantrip": "Cantrip",
  "feat": "Feat",
  "skill": "Skill",
  "expertise": "Expertise",
  "tool": "Tool"
};
const types_simple: DataType[] = [
  "spell",
  // "cantrip",
  "feat",
  "skill",
  // "expertise",
  "tool"
];

class SuggestionsForLevelInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      obj: props.obj,
      reloading: false,
      suggestions: props.obj.suggestions,
      expanded_type: ""
    };
  }

  componentDidMount() {
  }

  render() {
    const used_types = this.state.suggestions.map(o => { return o.type; });
    const ununsed_types = types_simple.filter(o => !used_types.includes(o));
    const next_type = ununsed_types.length === 0 ? "" : ununsed_types[0];
    return (
      <Grid container spacing={0} direction="column">
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 2
            }}>
            <Tooltip title={`Delete Level`}>
              <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                onClick={ () => {
                  this.props.onDelete();
                }}>
                <DeleteForever/>
              </Fab>
            </Tooltip>
          </Grid>
          <Grid
            size={{
              xs: 10
            }}>
            <SelectStringBox
              name="Level"
              options={CHARACTER_LEVELS}
              value={`${this.state.obj.level}`}
              onChange={(value: string) => {
                const obj = this.state.obj;
                obj.level = +value;
                this.props.onChange(obj);
              }}
            />
          </Grid>
        </Grid>
        <Grid style={{ color: "blue", fontWeight: "bold" }}>
          Types
          <Tooltip title={`Add New Type`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              disabled={ this.props.disabled || next_type === "" }
              onClick={ () => {
                if (isDataType(next_type)) {
                  const suggestions = this.state.suggestions;
                  suggestions.push({ type: next_type, ids: [] });
                  this.setState({ 
                    suggestions, 
                    expanded_type: next_type,
                    // reloading: true 
                  }, () => {
                    const obj = this.state.obj;
                    obj.suggestions = suggestions;
                    this.props.onChange(obj);
                    // this.setState({ reloading: false });
                  });
                }
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        </Grid>
        { !this.state.reloading && this.state.suggestions.map((type_sug, key) => {
          return (
            <Grid key={key} container spacing={0} direction="column">
              <Grid>
                <ToggleButtonBox 
                  name={ type_map[type_sug.type] }
                  value={ this.state.expanded_type === type_sug.type }
                  onToggle={() => {
                    this.setState({ expanded_type: (this.state.expanded_type === type_sug.type ? "" : type_sug.type) });
                  }}
                />
              </Grid>
              { this.state.expanded_type === type_sug.type &&
                <Grid>
                  <SuggestionsOfTypeInput
                    obj={{
                      type: type_sug.type,
                      ids: [...type_sug.ids]
                    }}
                    other_types={used_types}
                    disabled={this.props.disabled}
                    onChange={(changed: SuggestionsOfType) => {
                      const suggestions = this.state.suggestions;
                      const sug_finder = suggestions.filter(o => o.type === type_sug.type);
                      if (sug_finder.length === 1) {
                        const sug = sug_finder[0];
                        if (changed.type === type_sug.type) {
                          sug.ids = [...changed.ids];
                        } else {
                          sug.type = changed.type;
                          sug.ids = [];
                        }
                        this.setState({ 
                          suggestions, 
                          // reloading: true 
                        }, () => {
                          const obj = this.state.obj;
                          obj.suggestions = suggestions;
                          this.props.onChange(obj);
                          // this.setState({ reloading: false });
                        });
                      }
                    }}
                    onDelete={() => {
                      const suggestions = this.state.suggestions.filter(o => o.type !== type_sug.type);
                      this.setState({ 
                        suggestions, 
                        reloading: true 
                      }, () => {
                        const obj = this.state.obj;
                        obj.suggestions = suggestions;
                        this.props.onChange(obj);
                        this.setState({ reloading: false });
                      });
                    }}
                  />
                </Grid>
              }
            </Grid>
          );
        })}
      </Grid>
    );
  }
}

export default SuggestionsForLevelInput;
